const promoClinics = {
  'associates-of-marietta': {title: 'Associates of Marietta', foundationCode: 'associates-of-marietta'},
  'heart-2-heart': {title: 'Heart 2 Heart', foundationCode: 'heart-2-heart'},
  'womens-care': {title: 'Women\'s Care', foundationCode: 'womens-care'}
}

export default promoClinics